import { render, staticRenderFns } from "./Pennies.vue?vue&type=template&id=bdd661a0"
import script from "./Pennies.vue?vue&type=script&lang=js"
export * from "./Pennies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports